import React, { Component } from 'react';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import './styles.scss';

class AddTeamMemberLoader extends Component {
	render() {
		return (
			<div className="new-customer-container">
				<SkeletonTheme color="#848484" highlightColor="#373737">
					<div className="admin-body-container">
						<div className="admin-body-wrapper">
							<div className="admin-field-wrapper">
								<div className="user-info-container">
									<div className="circular-avatar">
										<Skeleton circle height={80} width={80} />
									</div>
									<p className="account-name-skeleton"> <Skeleton height={34} width={244} /></p>
									<p className="account-title"> <Skeleton height={34} width={244} /></p>
									<div className="details-wrapper">
										<div className="details-info">
											<p className="details-text"><Skeleton height={34} width={244} /></p>
										</div>
									</div>
								</div>
								<div className={'admin-field-wrapper'}>
									<p className="sub-header-text role-text"><Skeleton height={42} width={244} /></p>
									<p className="info-text"><Skeleton height={16} width={244} /></p>
								</div>
								<div className={'admin-field-wrapper'}>
									<div className={`subscription-list-wrapper`} >
										<Skeleton height={94} width={364} />
									</div>
									<div className={`subscription-list-wrapper`} >
										<Skeleton height={94} width={364} />
									</div>
								</div>
							</div>
							<div className="admin-field-wrapper">
								<div className="button-wrapper">
									<Skeleton className='ms-Button ms-Button--primary elliptical' height={56} width={267} />
								</div>
							</div>
						</div>
					</div>
				</SkeletonTheme>
			</div>
		);
	}
}

export default AddTeamMemberLoader;